import { Box, Tab } from '@mui/material'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import { Suspense, useState, useEffect } from 'react'
import ListModule from './ListModule'
import { useAuth } from '../../context/AuthContext'

const BASE_STORAGE_KEY = 'submodule_active_tab'

function SubModule({ options, defaultTab = '1' }) {
  const { user } = useAuth()
  const userId = user?.id || 'anon'
  const [activeTab, setActiveTab] = useState(defaultTab)
  const getStorageKey = (key = options.objectType) => `${BASE_STORAGE_KEY}_${key}_${userId}`
  useEffect(() => {
    const storageKey = getStorageKey()

    const savedTab = localStorage.getItem(storageKey)
    if (savedTab && options.tabsNames?.some((t) => t.tabIndex === savedTab)) {
      setActiveTab(savedTab)
    }
  }, [options.tabsNames, userId])

  const handleChangeActiveTab = (_event, newValue) => {
    setActiveTab(newValue)
    localStorage.setItem(getStorageKey(), newValue)
  }

  const activeTabConfig = options.tabs?.find((tab) => tab.tabIndex === activeTab)
  const ActiveTabComponent = activeTabConfig?.component

  return (
    <Box sx={{ marginBottom: '10px' }}>
      <TabContext value={activeTab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChangeActiveTab} aria-label='Général'>
            {options.tabsNames?.map((tab) =>
              tab.isDisplay?.() !== false ? <Tab key={tab.tabIndex} label={tab.tabName} value={tab.tabIndex} /> : null
            )}
          </TabList>
        </Box>

        <Box sx={{ mt: 2, px: 2 }}>
          {ActiveTabComponent ? (
            <Suspense fallback={<div>Chargement...</div>}>
              <ActiveTabComponent />
            </Suspense>
          ) : (
            activeTabConfig && <ListModule options={activeTabConfig.options} toolbar={activeTabConfig.toolbar} />
          )}
        </Box>
      </TabContext>
    </Box>
  )
}

export default SubModule
